import { Grid, Typography } from '@material-ui/core'

import moment from 'moment/moment'

import { a11yProps, Tab, TabPanel, Tabs } from 'asterX-UI/Tabs'
import { GRAY_COLORS } from 'asterX-UI'

import { useHomeStoreSpp } from 'context/HomeStore/SPP'
import { sppTabsList } from './constants'

export const SppTabs = () => {
  const {
    homeStore: { sppTab },
    homeStoreFunc: { setSppTab }
  } = useHomeStoreSpp()

  return (
    <Grid container spacing={8}>
      <Grid item xs={12}>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          style={{ borderBottom: `1px solid ${GRAY_COLORS[200]}` }}
        >
          <Grid item>
            <Tabs
              value={sppTab}
              onChange={(_, newValue) => setSppTab(newValue)}
            >
              {sppTabsList.map((item, i) => {
                const Icon = item?.icon || null

                return (
                  <Tab
                    {...a11yProps(i)}
                    key={`rop-tab-${i}`}
                    label={item?.label || ''}
                    icon={Icon && <Icon />}
                    value={i}
                  />
                )
              })}
            </Tabs>
          </Grid>

          <Grid item>
            <Typography
              variant="subtitle2"
              style={{ color: GRAY_COLORS[500], textTransform: 'capitalize' }}
            >
              {moment().format('dddd, D MMMM')}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        {sppTabsList.map((item, i) => {
          const Component = item.component

          return (
            <TabPanel key={`rop_tab_panel_${i}`} index={i} value={sppTab}>
              <Component />
            </TabPanel>
          )
        })}
      </Grid>
    </Grid>
  )
}
